<template>
  <div class="lottery-container">
    <div class="lottery-content">
      <img :src="bannerImage" alt="Lottery" class="lottery-image" />
      <button class="lottery-button" disabled>
        <span class="button-text">ซื้อหวย</span>
      </button>
    </div>
  </div>
</template>

<script>
import { cdnImage } from '@/utils/cdn'

export default {
  name: 'Lottery',
  data() {
    return {
      bannerImage: cdnImage('kaiju/banner/lotto.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
.lottery-container {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 300px;

  @media (max-width: 768px) {
    padding: 15px;
    min-height: 250px;
  }
}

.lottery-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;

  @media (max-width: 768px) {
    width: 85%;
  }

  @media (max-width: 480px) {
    width: 95%;
  }
}

.lottery-image {
  width: 80%;
  height: auto;
  display: block;
  object-fit: cover;
  border-radius: 16px;
  margin-bottom: 5px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.lottery-button {
  width: 80%;
  margin-top: 16px;
  padding: 18px 48px;
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #9333ea, #7c3aed, #6366f1);
  border: none;
  border-radius: 14px;
  cursor: not-allowed;
  box-shadow: 0 4px 20px rgba(147, 51, 234, 0.4), 0 2px 8px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.15),
      transparent
    );
    animation: shimmer 3s infinite;
  }

  .button-text {
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 1;
  }

  @media (max-width: 768px) {
    margin-top: 12px;
    padding: 14px 36px;
    font-size: 1.2rem;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    margin-top: 10px;
    padding: 12px 28px;
    font-size: 1rem;
    border-radius: 10px;
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>
